import type { AppRouter } from "@sp-crm/server/rpc";
import type { inferProcedureInput, inferProcedureOutput } from "@trpc/server";

export type GlobalClientSearchCriteria = Exclude<
    inferProcedureInput<AppRouter["clients"]["getClientsForDetails"]>,
    void
>;

export type ClientsSearchResult = inferProcedureOutput<
    AppRouter["clients"]["getClientsForDetails"]
>;

export type ClientForDetails = ClientsSearchResult["clients"][number];

export const clientCardType = "ClientCard" as const;
